module.exports = __webpack_public_path__ + "static/egyptian-bedding-set-grey-3-4065d4bb8d74691770ef247a0e050c93.png";